import { Box } from "@mui/material";
import React from "react";
import MUITypography from "../MUITypography";
import { align_center, align_column } from "../../Styles/VMStyles";

function TitleDesc(props) {
    const {title,subtitle}=props;
  return (
    <Box sx={{ ...align_center, ...align_column, m: 1 }}>
      <MUITypography
        m={1}
        variant="h2"
        component="h2"
        fontWeight="bold"
        gutterBottom
        label={title}
      />
      <MUITypography color="textSecondary" label={subtitle} />
    </Box>
  );
}

export default TitleDesc;
